import { Component, OnInit, Input, ChangeDetectionStrategy, NgModule, Inject } from '@angular/core';
import { SiteService } from '@app/services/site.service';
import { Observable, Subject, of } from 'rxjs';
import { NewsPage } from '@app/models/news-page';
import { startWith, map, catchError, mergeMap } from 'rxjs/operators';
import { UserChannelTermsService } from '@app/services/user-channel-terms.service';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { TextPlaceholderModule } from '@app/components/text-placeholder/text-placeholder.component';
import { ErrorTemplatesModule } from '@app/components/error-templates/error-templates.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { LinkModule } from '@app/directives/link.directive';
import { RouterModule } from '@angular/router';
import { NewsCardListModule } from '@app/components/news-card-list/news-card-list.component';
import { BlogService } from '../services/blog.service';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { CafcassEnvironment } from '../../environments/cafcassEnvironment';

@Component({
  selector: 'app-custom-my-blogs',
  templateUrl: './custom-my-blogs.component.html',
  styleUrls: ['./custom-my-blogs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomMyBlogsComponent implements OnInit {

  @Input() amountOfBlogPostsToDisplay = 6;
  @Input() maxNumberOfShowMore = 2; // How many times can you press the show more button

  private errorSubject$ = new Subject();
  private moreBlogPostsSubject = new Subject<number>();
  personalBlogItems$: Observable<Array<NewsPage>>;

  fetchedAmountOfPosts = 0;
  amountOfNewsToIncreaseWith = this.amountOfBlogPostsToDisplay;
  amountOfBlogPostsToDisplayCurrently = this.amountOfBlogPostsToDisplay;
  numberOfShowMoreClicks = 0;

  blogCenterUrl: string;
  loading = false;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: CafcassEnvironment,
              private service: BlogService,
              private userChannelTermsService: UserChannelTermsService,
              private siteService: SiteService) { }

  ngOnInit() {

    this.blogCenterUrl = this.environment.blogSiteUrl;

    this.personalBlogItems$ = this.moreBlogPostsSubject
      .pipe(
        startWith(this.amountOfBlogPostsToDisplayCurrently + 1),
        mergeMap(() => {
          this.loading = true;
          const channels$ = this.userChannelTermsService.getUserChannelTerms();
          return this.service.getMyModernPersonalNewsFromBlogSite(channels$);
        }),
        map((pages) => {
          pages.forEach(page => {
            if (page && (!page.SiteName || !page.SiteUrl)) {
              page.SiteInfo$ = this.siteService.getSiteInfoFromUrl(page.Path);
            }
          });

          this.fetchedAmountOfPosts = pages.length;
          if (this.fetchedAmountOfPosts > this.amountOfBlogPostsToDisplayCurrently) {
            pages = pages.slice(0, this.amountOfBlogPostsToDisplayCurrently);
          }
          this.loading = false;
          return pages;
        }),
        catchError(err => {
          this.errorSubject$.next(err);
          return of(null);
        }));
  }

  showMoreBlogPosts() {
    this.numberOfShowMoreClicks++;
    this.amountOfBlogPostsToDisplayCurrently = this.amountOfBlogPostsToDisplayCurrently + this.amountOfNewsToIncreaseWith;
    this.loading = true;
    this.moreBlogPostsSubject.next(this.amountOfBlogPostsToDisplayCurrently + 1);
  }
}
@NgModule({
  entryComponents: [CustomMyBlogsComponent],
  declarations: [CustomMyBlogsComponent],
  exports: [CustomMyBlogsComponent],
  imports: [
    CommonModule,
    NewsCardListModule,
    LinkModule,
    ActionLinkModule,
    MatButtonModule,
    RouterModule,
    ErrorTemplatesModule,
    TextPlaceholderModule,
    WidgetPlaceholderModule
  ]
})
export class CustomMyBlogsModule { }
